import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Order } from '../../models/Order';
import { getPendingOrders, changeOrderStatus } from '../../state/order/order.actions';
import { selectGetPendingOrders } from '../../state/order/order.selector';
import { PageHeaderComponent } from "../page-header/page-header.component";

@Component({
  selector: 'app-pending-orders',
  standalone: true,
  templateUrl: './pending-orders.component.html',
  styleUrl: './pending-orders.component.css',
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    PageHeaderComponent
],
})
export class PendingOrdersComponent implements OnInit {
  pendingOrders$: Observable<Order[]>;

  constructor(private store: Store) {
    this.pendingOrders$ = this.store.select(selectGetPendingOrders);
  }

  ngOnInit(): void {
    this.store.dispatch(getPendingOrders());
  }

  changeOrderStatus(orderId: number, action: 'approve' | 'decline'): void {
    this.store.dispatch(changeOrderStatus({ orderId, action }));
  }
}
